import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('services');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentStudioSlide, setCurrentStudioSlide] = useState(0);

  const heroImages = [
    {
      url: 'https://public.readdy.ai/ai/img_res/94f33ad7a5e09592c8dca457c76974ff.jpg',
      title: 'AIとホログラムで、未来のコミュニケーションをデザインする'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Advanced%20AI%20robot%20technology%20with%20holographic%20interface%2C%20futuristic%20artificial%20intelligence%20laboratory%2C%20glowing%20blue%20neural%20networks%2C%20sophisticated%20machine%20learning%20visualization%2C%20high-tech%20robotics%20development%20center%2C%20clean%20modern%20design%20with%20transparent%20screens%2C%20professional%20lighting%2C%20innovative%20technology%20atmosphere&width=1920&height=1080&seq=holo-hero-bg2&orientation=landscape',
      title: 'AI搭載ホログラムロボット「パペロボ」で革新を'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Futuristic%20broadcasting%20studio%20with%20holographic%20technology%2C%20advanced%20media%20production%20environment%2C%20transparent%20holographic%20displays%2C%20modern%20broadcast%20equipment%2C%20clean%20professional%20studio%20lighting%2C%20innovative%20communication%20technology%2C%20high-tech%20media%20center%20atmosphere%2C%20sleek%20contemporary%20design&width=1920&height=1080&seq=holo-hero-bg3&orientation=landscape',
      title: 'ホログラム放送局で新しいメディア体験を'
    }
  ];

  const studioImages = [
    {
      url: 'https://static.readdy.ai/image/9f6cb88bc53f7ed30ca4a8d6f26bfc95/417b88a0321075144a19fa114106a9e0.jfif',
      alt: 'ホログラム放送局スタジオ - メインスタジオ'
    },
    {
      url: 'https://static.readdy.ai/image/9f6cb88bc53f7ed30ca4a8d6f26bfc95/c6874d3d3b00bcb13bdc716183e4bd25.jfif',
      alt: 'ホログラム放送局スタジオ - 収録ブース'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const studioTimer = setInterval(() => {
      setCurrentStudioSlide((prev) => (prev + 1) % studioImages.length);
    }, 4000);

    return () => clearInterval(studioTimer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextStudioSlide = () => {
    setCurrentStudioSlide((prev) => (prev + 1) % studioImages.length);
  };

  const prevStudioSlide = () => {
    setCurrentStudioSlide((prev) => (prev - 1 + studioImages.length) % studioImages.length);
  };

  const goToStudioSlide = (index: number) => {
    setCurrentStudioSlide(index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with Carousel */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Carousel Images */}
        {heroImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              backgroundImage: `url('${image.url}')`
            }}
          />
        ))}

        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60" />

        {/* Navigation Arrows */}
        <button
          onClick={prevSlide}
          className="absolute left-4 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/20 backdrop-blur rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all z-20 cursor-pointer"
        >
          <i className="ri-arrow-left-line text-lg md:text-xl"></i>
        </button>

        <button
          onClick={nextSlide}
          className="absolute right-4 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/20 backdrop-blur rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-all z-20 cursor-pointer"
        >
          <i className="ri-arrow-right-line text-lg md:text-xl"></i>
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-3 z-20">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                index === currentSlide
                  ? 'bg-white scale-125'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>

        <div className="relative z-10 text-center text-white px-4 max-w-6xl mx-auto">
          <div className="mb-6 md:mb-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 md:mb-4 drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)] [text-shadow:_2px_2px_4px_rgb(0_0_0_/_80%)]">
              AICodeグループ
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl mb-4 md:mb-6 font-light drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)] [text-shadow:_2px_2px_4px_rgb(0_0_0_/_80%)]">
              AIロボット時代のIT企業グループ
            </p>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8 leading-tight transition-all duration-500 px-2 drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)] [text-shadow:_2px_2px_4px_rgb(0_0_0_/_80%)]">
            {heroImages[currentSlide].title}
          </h2>

          <p className="text-base sm:text-lg md:text-xl mb-8 md:mb-12 max-w-4xl mx-auto leading-relaxed px-2 drop-shadow-[0_4px_8px_rgba(0,0,0,0.8)] [text-shadow:_1px_1px_3px_rgb(0_0_0_/_80%)]">
            新世代のAI駆動開発ツールや、AI搭載ホログラムロボット「パペロボ」の開発販売。<br className="hidden sm:block" />
            グループ300名規模の優秀な技術者による先端テクノロジーで、シンギュラリティの後の世界を創造します！
          </p>

          <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center px-4">
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg">
              <i className="ri-play-circle-line mr-2"></i>
              パペロボを見る
            </button>
            <button 
              onClick={() => navigate('/media')}
              className="border-2 border-white text-white hover:bg-white hover:text-black px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-newspaper-line mr-2"></i>
              メディアを見る
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 px-2">私たちのサービス</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
              AIとホログラム技術の融合によって、革新的なソリューションを提供いたします
            </p>
          </div>

          {/* Tab Navigation */}
          <div className="flex justify-center mb-8 md:mb-12 px-4">
            <div className="bg-white rounded-full p-1.5 md:p-2 shadow-lg inline-flex flex-wrap justify-center gap-1">
              <button
                onClick={() => setActiveTab('services')}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-full transition-all whitespace-nowrap cursor-pointer text-sm md:text-base ${
                  activeTab === 'services' 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                主要サービス
              </button>
              <button
                onClick={() => setActiveTab('papeロbo')}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-full transition-all whitespace-nowrap cursor-pointer text-sm md:text-base ${
                  activeTab === 'papeロbo' 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                パペロボ
              </button>
              <button
                onClick={() => setActiveTab('studio')}
                className={`px-4 md:px-6 py-2 md:py-3 rounded-full transition-all whitespace-nowrap cursor-pointer text-sm md:text-base ${
                  activeTab === 'studio' 
                    ? 'bg-blue-600 text-white' 
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                スタジオレンタル
              </button>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'services' && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all cursor-pointer">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className="ri-code-line text-xl md:text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">ソフトウェア開発</h3>
                <p className="text-sm md:text-base text-gray-600">AI駆動開発ツールを活用した次世代のソフトウェアソリューション</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all cursor-pointer">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className="ri-robot-line text-xl md:text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">ホログラムロボット</h3>
                <p className="text-sm md:text-base text-gray-600">AI搭載ホログラムロボット「パペロボ」の開発・販売</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all cursor-pointer">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-green-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className="ri-broadcast-line text-xl md:text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">ホログラム放送局</h3>
                <p className="text-sm md:text-base text-gray-600">世界初のAI搭載ホログラムロボットによる放送局運営</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all cursor-pointer">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className="ri-smartphone-line text-xl md:text-2xl text-red-600"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">アプリ開発</h3>
                <p className="text-sm md:text-base text-gray-600">アプリケーションソフトウェアの企画・開発</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all cursor-pointer">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className="ri-settings-line text-xl md:text-2xl text-yellow-600"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">システム統合</h3>
                <p className="text-sm md:text-base text-gray-600">情報通信システムに関するSI事業</p>
              </div>

              <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 hover:shadow-xl transition-all cursor-pointer">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-indigo-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className="ri-brain-line text-xl md:text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">AIソリューション</h3>
                <p className="text-sm md:text-base text-gray-600">AI技術を活用したソリューション・サービス</p>
              </div>
            </div>
          )}

          {activeTab === 'papeロbo' && (
            <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <img 
                  src="https://static.readdy.ai/image/9f6cb88bc53f7ed30ca4a8d6f26bfc95/d0dd592b60fe473691a6d08b07841d9f.png"
                  alt="パペロボ"
                  className="w-full rounded-xl shadow-2xl object-cover object-top"
                />
              </div>
              <div className="px-4">
                <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">AI搭載ホログラムロボット「パペロボ」</h3>
                <p className="text-base md:text-lg text-gray-700 mb-6 md:mb-8 leading-relaxed">
                  縦長の3連ホログラムサイネージ型のAI搭載ロボットで、企業や店舗の広告だけでなく、
                  ホログラムでの社長や店主、有名人などの人物の再現が得意です。
                </p>
                
                <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                  <div className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-sm md:text-base">リアルな人物再現技術</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-sm md:text-base">AI音声認識・対話機能</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-sm md:text-base">多言語対応</span>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-check-line text-green-500 mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-sm md:text-base">カスタマイズ可能なコンテンツ</span>
                  </div>
                </div>

                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base">
                  <i className="ri-information-line mr-2"></i>
                  詳細を見る
                </button>
              </div>
            </div>
          )}

          {activeTab === 'studio' && (
            <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="px-4">
                <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">ホログラム放送局＆Studio</h3>
                <p className="text-base md:text-lg text-gray-700 mb-6 md:mb-8 leading-relaxed">
                  新宿に開設したホログラム放送局では、スタジオや放送機材、
                  ホログラムマシンの貸し出しを行っています。
                </p>
                
                <div className="bg-white rounded-xl p-5 md:p-6 shadow-lg mb-6 md:mb-8">
                  <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4">料金プラン</h4>
                  <div className="space-y-2 md:space-y-3">
                    <div className="flex justify-between items-center py-2 border-b text-sm md:text-base">
                      <span className="font-medium">1時間</span>
                      <span className="text-blue-600 font-bold">4,000円～</span>
                    </div>
                    <div className="flex justify-between items-center py-2 border-b text-sm md:text-base">
                      <span className="font-medium">1日 (10:00-18:00)</span>
                      <span className="text-blue-600 font-bold">20,000円～</span>
                    </div>
                    <div className="flex justify-between items-center py-2 text-sm md:text-base">
                      <span className="font-medium">24時間</span>
                      <span className="text-blue-600 font-bold">30,000円～</span>
                    </div>
                  </div>
                </div>

                <button className="bg-green-600 hover:bg-green-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer text-sm md:text-base">
                  <i className="ri-calendar-line mr-2"></i>
                  予約する
                </button>
              </div>
              <div className="relative">
                {/* Studio Image Carousel */}
                <div className="relative overflow-hidden rounded-xl shadow-2xl">
                  {studioImages.map((image, index) => (
                    <div
                      key={index}
                      className={`transition-opacity duration-1000 ${
                        index === currentStudioSlide ? 'opacity-100' : 'opacity-0 absolute inset-0'
                      }`}
                    >
                      <img 
                        src={image.url}
                        alt={image.alt}
                        className="w-full h-[400px] md:h-[600px] object-cover object-top"
                      />
                    </div>
                  ))}

                  {/* Studio Navigation Arrows */}
                  <button
                    onClick={prevStudioSlide}
                    className="absolute left-3 md:left-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 bg-black/30 backdrop-blur rounded-full flex items-center justify-center text-white hover:bg-black/50 transition-all z-10 cursor-pointer"
                  >
                    <i className="ri-arrow-left-line text-sm md:text-lg"></i>
                  </button>

                  <button
                    onClick={nextStudioSlide}
                    className="absolute right-3 md:right-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 bg-black/30 backdrop-blur rounded-full flex items-center justify-center text-white hover:bg-black/50 transition-all z-10 cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-sm md:text-lg"></i>
                  </button>

                  {/* Studio Slide Indicators */}
                  <div className="absolute bottom-3 md:bottom-4 left-1/2 -translate-x-1/2 flex space-x-2 z-10">
                    {studioImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => goToStudioSlide(index)}
                        className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                          index === currentStudioSlide
                            ? 'bg-white scale-125'
                            : 'bg-white/60 hover:bg-white/80'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-4 md:mb-6">私たちのビジョン</h2>
              <div className="text-xl md:text-2xl font-semibold text-blue-600 mb-4 md:mb-6">
                「AIとホログラムで、未来のコミュニケーションをデザインする」
              </div>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6 md:mb-8">
                VES株式会社は、AIとホログラムの融合によって、人々のコミュニケーションと体験を革新する企業です。
                私たちは、ホログラム技術で物理的な距離の限界を取り払い、リアルとバーチャルが共存する新しい社会を築くことを目指しています。
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                未来の放送は画面の中だけではなく、空間全体を活用する時代へ。
                独自に開発するホログラムロボット「パペロボ」は、教育・接客・受付など、
                幅広い分野で人々のパートナーとして活躍することを考えています。
              </p>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Futuristic%20vision%20of%20AI%20and%20hologram%20technology%20transforming%20human%20communication%2C%20people%20interacting%20with%20holographic%20displays%2C%20advanced%20digital%20society%2C%20bright%20optimistic%20future%2C%20clean%20modern%20design&width=600&height=500&seq=vision-1&orientation=landscape"
                alt="未来のビジョン"
                className="w-full rounded-xl shadow-2xl object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">最新情報</h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-3 mb-4">
                <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs md:text-sm font-medium">
                  プレスリリース
                </span>
                <span className="text-gray-500 text-xs md:text-sm">2025年10月</span>
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-3 leading-tight">【近隣地域優先】3Dスキャン体験データを先着100名様に無料プレゼント！</h3>
              <p className="text-sm md:text-base text-gray-600 mb-4">
                VES株式会社は、地域限定で3Dスキャン無料体験を実施中！先着100名様に、ご自身の3Dデータをプレゼント。
              </p>
              <a 
                href="https://prtimes.jp/main/html/rd/p/000000004.000168711.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold cursor-pointer text-sm md:text-base"
              >
                記事を読む <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-3 mb-4">
                <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs md:text-sm font-medium">
                  プレスリリース
                </span>
                <span className="text-gray-500 text-xs md:text-sm">2024年3月</span>
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-3 leading-tight">AI搭載ホログラムロボット「パペロボ」発表</h3>
              <p className="text-sm md:text-base text-gray-600 mb-4">
                当社のAI搭載ホログラムロボット「パペロボ」に関する最新情報をPR TIMESにて公開しております。
              </p>
              <a 
                href="https://prtimes.jp/main/html/rd/p/000000001.000168711.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold cursor-pointer text-sm md:text-base"
              >
                記事を読む <i className="ri-external-link-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 md:py-20 bg-blue-600">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 md:mb-8">お問い合わせ</h2>
          <p className="text-lg md:text-xl text-blue-100 mb-8 md:mb-12 px-4">
            AIホログラム技術について、お気軽にお問い合わせください
          </p>
          
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-8 md:mb-12">
            <div className="bg-white/10 backdrop-blur rounded-xl p-6 md:p-8">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2">お電話でのお問い合わせ</h3>
              <p className="text-xl md:text-2xl font-bold text-white">03-5990-2985</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur rounded-xl p-6 md:p-8">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2">メールでのお問い合わせ</h3>
              <p className="text-base md:text-lg text-white break-all px-2">holo.channel-info@es-grp.jp</p>
            </div>
          </div>
          
          <button className="bg-white text-blue-600 hover:bg-gray-100 px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            onClick={() => navigate('/contact')}
          >
            <i className="ri-send-plane-line mr-2"></i>
            お問い合わせフォーム
          </button>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6">会社概要</h2>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
            <div>
              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mb-6 md:mb-8">
                <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6">VES株式会社</h3>
                <div className="space-y-3 md:space-y-4 text-sm md:text-base">
                  <div className="grid grid-cols-3 gap-2 md:gap-4">
                    <span className="font-semibold text-gray-600">設立日：</span>
                    <span className="col-span-2">2019年7月29日</span>
                  </div>
                  <div className="grid grid-cols-3 gap-2 md:gap-4">
                    <span className="font-semibold text-gray-600">資本金：</span>
                    <span className="col-span-2">100万円</span>
                  </div>
                  <div className="grid grid-cols-3 gap-2 md:gap-4">
                    <span className="font-semibold text-gray-600">代表取締役：</span>
                    <span className="col-span-2">小林 雅巳</span>
                  </div>
                  <div className="grid grid-cols-3 gap-2 md:gap-4">
                    <span className="font-semibold text-gray-600">住所：</span>
                    <span className="col-span-2">
                      〒160-0022<br />
                      東京都新宿区新宿1-34-14<br />
                      第二貝塚ビル101<br />
                      （ホログラム放送局）
                    </span>
                  </div>
                </div>
              </div>

              {/* Google Map */}
              <div className="bg-gray-50 rounded-xl p-5 md:p-6">
                <h4 className="text-lg md:text-xl font-bold mb-3 md:mb-4 flex items-center">
                  <i className="ri-map-pin-line text-blue-600 mr-2"></i>
                  アクセス
                </h4>
                <div className="aspect-video rounded-lg overflow-hidden shadow-lg">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.6967543567434!2d139.70247831525326!3d35.688651880189936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cd0d2e1a5a7%3A0x1c32a1f1ecb2c4a5!2z5paw5a6_77yR5LiB55uu77yT77yU4oiS77yR77yU!5e0!3m2!1sja!2sjp!4v1647321234567!5m2!1sja!2sjp"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="VES株式会社 所在地"
                  ></iframe>
                </div>
                <div className="mt-3 md:mt-4 text-xs md:text-sm text-gray-600">
                  <p className="flex items-center mb-2">
                    <i className="ri-subway-line text-blue-600 mr-2 flex-shrink-0"></i>
                    <span>新宿三丁目駅C７出口より徒歩５分</span>
                  </p>
                  <p className="flex items-center">
                    <i className="ri-subway-line text-blue-600 mr-2 flex-shrink-0"></i>
                    <span>新宿御苑前駅より徒歩５分</span>
                  </p>
                </div>
              </div>

            </div>
            
            <div>
              <div className="mb-6 md:mb-8">
                <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">コンテンツ事業</h3>
                <ul className="space-y-2 text-sm md:text-base">
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>ソフトウェア開発</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>情報通信システムに関するSI事業</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>アプリケーションソフトウェアの企画・開発</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>ホログラムロボット「パペロボ」開発</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>ホログラム放送局事業＆スタジオレンタル</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                    <span>AI技術が活用したソリューション・サービス</span>
                  </li>
                </ul>
              </div>
              
              <img 
                src="https://static.readdy.ai/image/9f6cb88bc53f7ed30ca4a8d6f26bfc95/5929bfa2c2c8e15a7cc8baf37f2e7123.jfif"
                alt="会社オフィス"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-6 md:gap-8">
            <div className="md:col-span-2">
              <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">
                AI Code グループ
              </h3>
              <p className="text-sm md:text-base text-gray-300 mb-4 md:mb-6 leading-relaxed">
                AIとホログラムで、未来のコミュニケーションをデザインする企業です。
                革新的な技術で、より豊かな未来を創造していきます。
              </p>
              <div className="flex space-x-4">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                  <i className="ri-twitter-line"></i>
                </div>
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                  <i className="ri-facebook-line"></i>
                </div>
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-700 transition-colors">
                  <i className="ri-linkedin-line"></i>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="text-base md:text-lg font-semibold mb-3 md:mb-4">サービス</h4>
              <ul className="space-y-2 text-sm md:text-base text-gray-300">
                <li><a href="#" className="hover:text-white cursor-pointer">パペロボ</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">ホログラム放送局</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">スタジオレンタル</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">AIソリューション</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-base md:text-lg font-semibold mb-3 md:mb-4">クイックリンク</h4>
              <ul className="space-y-2 text-sm md:text-base text-gray-300">
                <li><a href="#" className="hover:text-white cursor-pointer">会社概要</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">お問い合わせ</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">プライバシーポリシー</a></li>
                <li><a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Made with Readdy</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 md:mt-12 pt-6 md:pt-8 text-center text-gray-400 text-xs md:text-sm">
            <p>&copy; 2024 VES株式会社. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
